module.exports = __webpack_public_path__ + "static/05-ab9f6c9579fd291b7c399da2712b3588.jpg";